import { ofType, type Epic } from 'redux-observable';
import { from } from 'rxjs';
import { mergeMap, map, catchError } from 'rxjs/operators';

import Auth from '../../api/auth';
import { handleError } from '../errorHandler';

import { FETCH_ORGANIZATIONS_STARTED, fetchOrganizationsFulfilled } from './actions';

const fetchOrganizationsEpic: Epic = action$ =>
  action$.pipe(
    ofType(FETCH_ORGANIZATIONS_STARTED),
    mergeMap((action: { payload: Record<string, unknown> }) =>
      from(Auth.fetchV1Organizations(action.payload)).pipe(
        map((response: { data: unknown }) => fetchOrganizationsFulfilled(response.data)),
        catchError(handleError)
      )
    )
  );

export default fetchOrganizationsEpic;
